<template>
    <div class="page-wrapper register-page">
        <div class="page-bg"></div>
        <div class="page-content">
            <TopBarImage></TopBarImage>
            <div class="wrapper-register">
                <div class="wrapper-header">
                    <div class="header-register">
                        <div class="text">
                            <p>{{lbl.register.formRegister.register_lbl}}</p>
                        </div>
                    </div>
                    <div class="profile-image">
                        <img :src="linePicture" v-if="isLineLogin">
                    </div>
                </div>

                <div class="register-form">
                    <GenderRadio
                        :isTitle="true"
                        id='gender_radio'
                        :inputId="'title'"
                        :inputLbl='lbl.register.formRegister.title'
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"
                        v-model="formRegister.title" 
                        @input="onUpdateForm()"/>
                    <TextInput
                        inputId="firstname"
                        :inputLbl="lbl.register.formRegister.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :isTextOnly="true"
                        :isRequired="true"
                        :errorInfo="errorInfo[1]"
                        v-model="formRegister.firstname" 
                        @input="onUpdateForm()"/>
                    <TextInput
                        inputId="lastname"
                        :inputLbl="lbl.register.formRegister.lastname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :isTextOnly="true"
                        :isRequired="true"
                        :errorInfo="errorInfo[2]"
                        v-model="formRegister.lastname" 
                        @input="onUpdateForm()"/>
                    <GenderRadio
                        :isGender="true"
                        id='gender_radio'
                        :inputId="'gender'"
                        :inputLbl='lbl.register.formRegister.gender'
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[3]"
                        v-model="formRegister.gender" 
                        @input="onUpdateForm()"/>
                    <DropdownDatePicker
                        v-model="formRegister.birthdate"
                        :formId="'formInfo'"
                        :inputLbl="lbl.register.formRegister.birthdate"
                        :isFirstSave="false"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="errorInfo[4]"
                        :isRequired="true"
                        @onDateChange="onDatePickerSelected($event)"
                        @validateAge="validateAge($event)"
                    ></DropdownDatePicker>
                    <TextInput
                        inputId="contact-number"
                        :inputLbl="lbl.register.formRegister.contactnumber"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[5]"
                        :blockAutoComplete="true"
                        :isRequired="true"
                        v-model="formRegister.contactNumber" 
                        @input="onUpdateForm()"/>
                    <Email
                        inputId="email"
                        :inputLbl="lbl.register.formRegister.email"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="errorInfo[6]"
                        v-model="formRegister.email"
                        :isRequired="true"
                        @input="onUpdateForm()"/>
                    <TextAreaInput
                        addClass="register-info"
                        inputId="register_address_input"
                        :inputLbl="lbl.register.formRegister.shipping.address"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[7]"
                        :isRequired="true"
                        v-model="formRegister.address" 
                        @input="onUpdateForm()"/>
                    <FormAddressDropDown
                        :formId="'formRegister'"
                        :address="registerAddress"
                        inputId="registerAddress"
                        :lblShipping="lbl.register.formRegister.shipping"
                        :zipcodeError="errorInfo[8]"
                        :provinceError="errorInfo[9]"
                        :districtError="errorInfo[10]"
                        :subDistrictError="errorInfo[11]"
                        :isRequired="true"
                        @input="onUpdateForm()"/>

                    <div>
                        <BoxConsent 
                                    ref="input-consent"
                                    :lbl="lbl"
                                    :modalController="modalController"
                                    :marketingRegister="marketingRegister"
                                    :isAge20="isAge20"
                                    @marketing="onCheckBoxMarketing($event)"
                                    @acceptNews="validateMarketing($event)"
                                    @onValidateForm="onValidateForm($event)" />
                    </div>
                    <div class="btn-register" v-if="isAcceptConsent && isFormValid" @click="clickRegister()">
                        <div class="btn-txt">
                            {{lbl.register.btn_next}}
                        </div>
                    </div>

                    <div class="btn-register disabled" v-else>
                        <div class="btn-txt">
                            {{lbl.register.btn_next}}
                        </div>
                    </div>

                    <div class="btn-cancel" @click="clickToLogin()">{{lbl.register.btn_cancel}}</div>
                    <!-- <div class="register-line"></div> -->
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//import Vue from 'vue';
import Util from '@/helper/Utility.js';
import Account from '@/helper/AccountHelper.js';
import FormHelper from '@/helper/FormHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
import LineFunction from "@/helper/facade/LineFunction.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TopBarImage from '@/components/Layout/TopbarImage/TopBarImage.vue';
import GenderRadio from '@/components/Input/GenderRadio.vue';
//import InputContactNumber from '@/components/Input/ContactNumber.vue';
import TextInput from "@/components/Input/Text.vue";
import FormAddressDropDown from "@/components/Form/FormAddressDropDown.vue";
import DropdownDatePicker from '@/components/Input/DropdownDatePicker.vue';
import Email from '@/components/Input/Email.vue'
import TextAreaInput from '@/components/Input/TextAreaInput.vue';
import BoxConsent from '../component/BoxConsent.vue';
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { AddressParamsBuilder } from "@/core/Account/model/AccountModel.js";
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign';

export default {
    name: 'RegisterPage',
    components: {
        TopBarImage,
        GenderRadio,
        TextInput,
        //InputContactNumber,
        DropdownDatePicker,
        Email,
        TextAreaInput,
        FormAddressDropDown,
        BoxConsent
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            token: null,
            idToken: null,
            errorInfo: [],
            isShowErrorLbl: true,
            isFirstSave: true,
            registerAddress: new AddressModel(),
            formRegister: {
                email: '',
                title: '',
                firstname: '',
                lastname: '',
                birthdate: null,
                birthdateformat: '',
                contactNumber: '',
                address: '',
                gender: ''
            },
            isAcceptConsent: false,
            isFormValid: false,
            isAcceptNews: false,
            isMarketing: {
                email: null,
                line: null,
                notification: null,
                sms: null,
                consentAge: 20
            },
            isAge20: false,
            welcomePoint: 0,
            registerPoint: 0,
            welcomeCoupon: null,
            termsVersion: 1,
            privacyVersion: 1,
            marketingVersion: 1,
            marketingRegister: false,
            otp: '',
            prefill: '',
            cache: new CacheHelper('session'),

            isLineLogin: false,
            liffId: null,
            lineProfile: null,
            linePicture: null,
            getFriendCode: '',

            tracking: new TrackingService(this)
        };
    },
    created: function() {
        //this.idToken = this.cache.getCache('LineIdToken');
        var prefill_cache = this.cache.getCache('registerPrefill');
        if(prefill_cache){
            console.log("pre", prefill_cache);
            this.prefill = prefill_cache;
            this.initPrefillData();
        }

        if(this.cache.getCache('friendcode')){
            this.cache.removeCache('friendcode');
        }

        this.getFriendCode = this.$route.query.getFriendCode;
        this.otp = this.cache.getCache('registerOTP');
        this.formRegister.contactNumber = this.getPhoneFormat();

        this.initialOtherModal();
        this.initLiff();

        this.errorInfo = FormHelper.genErrorInfo(12);
        this.tracking.screenName('Register_Page');
    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();
            //this.liffId = '1655767597-WNALg1zg'; //stg

            lineFunction.init(this.liffId).then(() => {
                var currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    this.idToken = lineFunction.getIdToken();

                    lineFunction.getProfile().then((data) =>{
                        console.log('data', data);
                        this.isLineLogin = true;
                        this.linePicture = data.pictureUrl;
                        console.log('Pic', this.linePicture);
                    });
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        initPrefillData: function(){
            this.formRegister.title = this.prefill.Title;
            this.formRegister.firstname = this.prefill.FirstName;
            this.formRegister.lastname = this.prefill.LastName;
        },
        clickRegister: function() {
            var isEmailValid = this.validateEmail();

            if(this.isFormValid && isEmailValid){

                console.log("register");
                this.isRegister = true;
                this.checkMarketing();
                this.createRegisterModel();
            }else{
                this.isRegister = false;
                this.checkMarketing();
            }

            this.isFirstSave = false;
            this.tracking.event('create_account','click_confirm_register');
        },
        checkMarketing: function() {
            if(this.isRegister) {
                if (this.isAcceptNews) {
                    this.createRegisterModel();
                } else {
                    this.confirmModal
                        .setTitle(this.lbl.static.marketing.modal.title)
                        .setMsg(this.lbl.static.marketing.modal.msg)
                        .setBtnOk(this.lbl.static.marketing.modal.btn_accept)
                        .setBtnCancel(this.lbl.static.marketing.modal.btn_unaccept)
                        .setTag('marketing')
                        .show();

                    this.confirmModal.onClickOk((data) => {
                        if (data.tag == 'marketing') {
                            this.marketingModal.clearText()
                                            .setTag('box-consent')
                                            .show()
                            this.marketingModal.onClickOk((data) =>{
                                this.marketingRegister = true;
                                this.isMarketing = {
                                    email: data.email,
                                    sms: data.sms,
                                    line: data.line,
                                }
                                this.createRegisterModel();
                            });
                        }
                    });
                    this.confirmModal.onClickCancel(() => {
                        this.isMarketing = {
                            email: 0,
                            sms: 0,
                            line: 0,
                        }
                        this.createRegisterModel();
                    });
                }
            }
        },
        createRegisterModel: function(){
            var registerModel = {
                title: this.formRegister.title,
                gender: this.formRegister.gender,
                firstname: this.formRegister.firstname,
                lastname: this.formRegister.lastname,
                contact_number: this.otp.contactNumber,
            }

            if(this.formRegister.birthdateformat){
                registerModel.birthdate = this.formRegister.birthdateformat;
            }

            if(this.formRegister.email){
                registerModel.email = this.formRegister.email;
            }

            if(this.getFriendCode){
                registerModel.refusercode = this.getFriendCode;
            }

            console.log('address', this.registerAddress)
            this.registerAddress.address = this.formRegister.address;

            var address = new AddressParamsBuilder();
                address = address.getParams(this.registerAddress);
                registerModel = {...registerModel, ...address};

            var otpModel = {
                refcode: this.otp.refcode,
                otp: this.otp.otp,
            }

            var otherModel = {
                termAndCondition: this.termsVersion,
                dataPrivacy: this.privacyVersion
            }
            this.cache.setCache('form_register',registerModel);
            this.cache.setCache('otpModel', otpModel);
            this.cache.setCache('otherModel', otherModel);
            this.cache.setCache('isMarketing', this.isMarketing);
            this.cache.setCache('marketingVersion', this.marketingVersion);
            this.$router.push('/survey')
            // this.registerUser(registerModel, otpModel, otherModel);
        },
        registerUser: function(register, otp, other){
            this.loadingModal.show();
            //this.idToken = this.cache.getCache('LineIdToken');
            BzbsProfile.registerLine(register, this.idToken, otp, other).subscribe((res) => {
                console.log("res", res);
                this.loadingModal.hide();
                
                //welcome point
                if(res.buzzebees){  
                    // this.welcomePoint = res.buzzebees.traces[0].Points;
                    // let traces_point = res.buzzebees.traces.filter(o => (o.Points >= 0))[0];
                    let traces_point = res.buzzebees.traces.filter(o => (o.Id.indexOf("BiodermaRegister") >= 0))[0];
                    if(traces_point && traces_point.Points > 0){
                        this.welcomePoint = traces_point.Points;
                    }

                    let traces_coupon = res.buzzebees.traces.filter(o => (o.Id.indexOf("BiodermaRegister_WelcomeGift") >= 0))[0];
                    console.log('traces_coupon', traces_coupon)
                    if(traces_coupon){
                        this.welcomeCoupon = traces_coupon;
                    }
                    this.cache.setCache('welcomePoint', this.welcomePoint);
                    this.cache.setCache('welcomeCoupon', this.welcomeCoupon);
                }

                this.lineLogin();

            },(error) =>{
                this.isRegister = false;
                this.loadingModal.hide();

                if(error.id == 2128){
                     this.alertRegisterModal
                        .setTitle(this.lbl.register.alert.text_title)
                        .setMsg(this.lbl.register.alert.text_msg)
                        .setBtnOk(this.lbl.register.alert.text_try)
                        .show();
                }else{
                    this.errorApi(error);
                }

            });
        },
        lineLogin: function(){
            BzbsAuth.apiLoginLine(this.idToken).subscribe((res) => {
                this.cache.removeCache('registerOTP');

                Account.setLogin(res);

                if(res.buzzebees){
                    this.registerPoint = res.buzzebees.traces[0].Points;
                }
                this.submitConsent();

            },(err) => {
                this.loadingModal.hide();
                console.log(err.response.data);
                 window.location.replace('/linelogin');
            });
        },
        submitConsent: function(){
            //Save Consent
            var token = this.getToken();
            let consentModel = new PDPAModel();
            var consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.isMarketing.email,
                sms: this.isMarketing.sms,
                notification: this.isMarketing.notification,
                line: this.isMarketing.line,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(consent);
            let params = consentModel.getParams();
            BzbsPDPA.apiPostConsent(token, params)
                .subscribe((result) => {
                    console.log(result);
                    this.loadingModal.hide();

                    //show welcome popup
                    this.showWelcomePopup();

                    return Account.apiGetProfile();
                },(error) => {
                    this.loadingModal.hide();
                    console.log(error);
                });
        },
        showWelcomePopup: function(){
            //show welcome point
            setTimeout(() => {
                this.welcomePointModal
                    .setRegisterPoint(this.registerPoint)
                    .setMsg(this.welcomePoint)
                    .setTag('welcome-point')
                    .show();

                this.welcomePointModal.onClickOk(async (data) =>{
                    if(data.tag == 'welcome-point'){
                        if(this.welcomeCoupon){
                            console.log('welcome', this.welcomeCoupon);
                            let campaignId = this.welcomeCoupon.UserDescription;
                            let couponInfo = JSON.parse(this.welcomeCoupon.CustomInfo);
                            let msg = couponInfo.l_title

                            let campaign = await this.getCampaign(campaignId);
                            let btn = '';
                            let isDisable = false;
                            if(campaign){
                                if(campaign.qty <= 0){
                                    isDisable = true;
                                    btn = couponInfo.l_description_2nd;
                                }else{
                                    btn = couponInfo.l_description;
                                }
                            }

                            this.welcomeCouponModal.clearText()
                                .setMsg(msg)
                                .setBtnOk(btn)
                                .setIsDisable(isDisable)
                                .setTag('welcome-coupon')
                                .show();

                            this.welcomeCouponModal.onClickOk((data) =>{
                                if(data.tag == 'welcome-coupon'){
                                    if(campaign){
                                        if(campaign.qty <= 0){
                                            window.location.replace('/home');
                                        }else{
                                            let cacheCookie = new CacheHelper();
                                            cacheCookie.setCache('isRegisterSurvey', 'register_survey');
                                            window.location.replace(`/reward/${campaignId}`);
                                        }
                                    }
                                }
                            });
                            this.welcomeCouponModal.onClickCancel((data) =>{
                                if(data.tag == 'welcome-coupon'){
                                    window.location.replace('/home');
                                }
                            });
                        }else{
                            window.location.replace('/home');
                        }
                    }
                })

            },0)
        },
        getCampaign: function(campaignId){
            return new Promise((resolve) => {
                var token = this.getToken();
                let campaignConfig = new CampaignConfigBuilder()
                    .setCampaignId(campaignId)
                    .create();

                    BzbsCampaign.apiGetCampaignDetail(token, campaignConfig).subscribe((campaign) => {
                        console.log('campaign', campaign);
                        resolve(campaign);
                    }, (err) => {
                        this.errorApi(err);
                    });
            });
           
        },

        validateEmail: function(){
            if(this.formRegister.email){
                if(!this.errorInfo[6].isValid) return false;
                else return true;
            }else{
                return true;
            }
        },
        getPhoneFormat: function(){
            var mobile = Util.contactNumberFormat(this.otp.contactNumber, '-').slice(0, -4) + "xxxx";

            return mobile;
        },
        onPickedDate: function() {
            console.log(this.formRegister.birthdate);
        },
        onCheckBoxMarketing: function (marketing) {
            this.isMarketing = {
                email: marketing.email == true ? 1 : 0,
                line: marketing.line == true ? 1 : 0,
                notification: marketing.notification == true ? 1 : 0,
                sms: marketing.sms == true ? 1 : 0,
                marketingOption: this.marketingVersion
            }
        },
        validateMarketing: function (accept) {
            this.isAcceptNews = accept;
        },
        onValidateForm: function (data) {
            this.isAcceptConsent = data;
        },
        onDatePickerSelected: function(obj) {
            this.formRegister.birthdateformat = obj.timestamp;
            console.log(obj);
            this.onUpdateForm();
        },
        clickToLogin: function(){
            window.location.replace('/login');
        },
        validateAge: function(isAge20){
            this.isAge20 = isAge20;
            this.$refs['input-consent'].checkAge(isAge20);
        },
        onUpdateForm: function(){
            let valid = FormHelper.validate(this.errorInfo);
            console.log('valid', valid);
            this.isFormValid = valid;
        }
    },
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
@import "../style/register.scss";
</style>
<style lang="scss">
.register-page{
    .register-form{
        .wrap-input{
            .label.error{
                color: unset;
            }
            .input-box{
                position: unset;

                .error.input-field{
                    border-color: unset;
                }
            }
            .error-text{
                font-size: 1rem;
                text-align: left;
                margin-top: 10px;
                margin-left: 10px;
            }
        }
        .ddl-input{
            // margin-top: -15px;
        }
    }
}
</style>
